export default __webpack_public_path__ + "6c809a08e68d722781b2667db9bb0fe5.woff2";